function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import isEmpty from 'lodash/isEmpty';
import * as shapes from '../shapes';
import messages from '../messages';
import OrganizationMembershipBox from './OrganizationMembershipBox';
import styles from './OrganizationAdmin.pcss';
var _React_PureComponent;
class OrganizationMembershipsAbstract extends (_React_PureComponent = React.PureComponent) {
    onOpenModal(modalId, organizationMembership) {
        this.activeOrganizationMembership = organizationMembership;
        this.props.onOpenModal(modalId);
    }
    onCloseModal() {
        this.activeOrganizationMembership = null;
        this.props.onCloseModal();
    }
    get menuActions() {
        return null;
    }
    get organizationMemberships() {
        const { organizationMemberships, adminOrganizationMembership } = this.props;
        return organizationMemberships && organizationMemberships.filter((om)=>om.identityUID !== adminOrganizationMembership.identityUID && om.status === this.status);
    }
    renderEmpty() {
        return /*#__PURE__*/ _jsx("div", {
            className: styles.empty
        });
    }
    renderIsAdminHeader() {
        if (this.status === 'Pending') {
            return null;
        }
        return /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.admin));
    }
    renderMembershipsHead() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "row text--base text--light",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "col-7",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.nameAndEmail))
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-2",
                    children: this.renderIsAdminHeader()
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "col-2",
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.headers.profile))
                })
            ]
        });
    }
    renderMemberships(organizationMemberships, menuActions) {
        return organizationMemberships.map((organizationMembership)=>/*#__PURE__*/ _jsx(OrganizationMembershipBox, {
                organizationMembership: organizationMembership,
                menuActions: menuActions
            }, organizationMembership.identityUID));
    }
    renderContent() {
        const { organizationMemberships, menuActions } = this;
        if (!organizationMemberships) {
            return null;
        }
        if (isEmpty(organizationMemberships)) {
            return this.renderEmpty();
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                this.renderMembershipsHead(),
                /*#__PURE__*/ _jsx("div", {
                    className: "form-groups",
                    children: this.renderMemberships(organizationMemberships, menuActions)
                })
            ]
        });
    }
    renderModals() {
        return null;
    }
    renderHeaderMessage() {
        return null;
    }
    renderHeaderControls() {
        return null;
    }
    render() {
        if (!this.props.adminOrganizationMembership.isAdmin) {
            return null;
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsxs("section", {
                    className: "mt-8",
                    children: [
                        /*#__PURE__*/ _jsx("header", {
                            className: "section__header",
                            children: /*#__PURE__*/ _jsxs("div", {
                                className: "row align-items-end",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col",
                                        children: /*#__PURE__*/ _jsx("h4", {
                                            className: "text--h4",
                                            children: this.renderHeaderMessage()
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-auto",
                                        children: this.renderHeaderControls()
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "section",
                            children: this.renderContent()
                        })
                    ]
                }),
                this.renderModals()
            ]
        });
    }
    constructor(props){
        super(props);
        this.activeOrganizationMembership = null;
        this.status = null;
    }
}
_define_property(OrganizationMembershipsAbstract, "propTypes", {
    // Explicit props
    adminOrganizationMembership: PropTypes.shape({
        organizationUID: PropTypes.string.isRequired,
        identityUID: PropTypes.string.isRequired,
        isAdmin: PropTypes.bool.isRequired
    }).isRequired,
    // Implicit props
    organizationMemberships: PropTypes.arrayOf(shapes.organizationMembership),
    isInProgress: PropTypes.bool,
    openModalId: PropTypes.string,
    // Implicit actions
    onOpenModal: PropTypes.func,
    onCloseModal: PropTypes.func
});
export default OrganizationMembershipsAbstract;
